import axios from "./axiosinstance";

const TestCaseApi = {
  create: (data) =>
    axios.post(
      "/test-cases",
      data,
    ),

  getProjectTestCases: (
    projectId,
  ) =>
    axios.get(
      `/test-cases/project/${projectId}`,
    ),

  getDetails: (id) =>
    axios.get(
      `/test-cases/${id}`,
    ),

  update: (
    id,
    data,
  ) =>
    axios.put(
      `/test-cases/${id}`,
      data,
    ),

  updateStatus: (
    id,
    data,
  ) =>
    axios.put(
      `/test-cases/${id}/status`,
      data,
    ),

  delete: (id) =>
    axios.delete(
      `/test-cases/${id}`,
    ),
};

export default TestCaseApi;